import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';

interface CollectionCodeTrackingState extends ListState<any> {
 
}
class CollectionCodeTrackingModule extends ListModule<CollectionCodeTrackingState, any, any>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,
    }
    actions = {
        async getAll(context: ActionContext<CollectionCodeTrackingState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get(`/api/services/app/CollectionCode/${payload.data.id}/tracking`, { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
    };
    mutations = {
        setCurrentPage(state: CollectionCodeTrackingState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: CollectionCodeTrackingState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}
const collectionCodeTrackingModule = new CollectionCodeTrackingModule();
export default collectionCodeTrackingModule;